import { selectCurrentUser } from 'features/auth/slice';
import { useSelector } from 'react-redux';

import {
  formatTimeAgo,
  Markdown,
  recordsMatch,
} from '@frontendmentorio/design-system-v2';

import MarkHelpful from '../MarkHelpful';
import UpvoteButton from '../UpvoteButton';
import UserDetails from 'features/learners/UserDetails';

export default function Content({ comment }) {
  const currentUser = useSelector(selectCurrentUser);
  const isAuthor = recordsMatch(comment.user, currentUser);

  return (
    <div className="flex flex-col gap-4" id={`comment-${comment.id}`}>
      <div className="flex flex-wrap items-center gap-3 w-full">
        <UserDetails
          className="mr-auto overflow-x-hidden pt-1"
          user={comment.user}
        />

        <time className="italic text-neutral-500 text-sm">
          Posted {formatTimeAgo(comment.createdAt)}
        </time>
      </div>

      <Markdown>{comment.content}</Markdown>

      <div className="flex justify-between">
        <UpvoteButton comment={comment} disabled={isAuthor} />
        <MarkHelpful comment={comment} />
      </div>
    </div>
  );
}
